<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-27 15:14:54
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-10 13:59:33
 * @FilePath: /chaoyongtuan/src/components/ui/bottomFixed/bottomFixed.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="bottom-fixed" :style="myStyle">
        <slot class="slot-style"></slot>
    </div>
</template>
<script>
export default{
    data(){
        return {
            contentWidth: 192,
            zoomWidth: 167,
        }
    },
    props:{
        subtractWidth:{
            type: Number,
            default: 0,
        }
    },
    computed:{
        myStyle({contentWidth,zoomWidth, subtractWidth}){
            const totalContentWidth = contentWidth + subtractWidth;
            const totalZoomWidth = zoomWidth + subtractWidth;
            return {
                '---contentWidth' : totalContentWidth + 'px',
                '---zoomWidth' : totalZoomWidth + 'px',
            }
        },
    }
}
</script>
<style lang="less" scoped>
.bottom-fixed {
    padding-right: 20px;
    width:calc( 100vw -  var(---contentWidth));
    border-radius: 4px 4px 0 0;
    background: @color-gy1;
	position: fixed;
    display: flex;
    align-items: center;
    height: 60px;
	bottom: 0px;
	right: 25px;
	z-index: 110;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.06);
}

@media screen and (max-width: 1365px) {
	.bottom-fixed {
		width: calc(100vw - var(---zoomWidth)) !important;
		right: 0px !important;
	}
}
.bottom-fixed{
    /deep/ .el-pagination__total{
        position: relative;
        top: 2px !important;
    }
}
</style>